import React from 'react'

import { Card } from '@material-ui/core'
import TicketHeaderSkeleton from '../TicketHeaderSkeleton'

import { useStyles } from './style'

const TicketHeader = ({ loading, children }) => {
  const classes = useStyles()
  return (
    <>
      {loading ? (
        <TicketHeaderSkeleton />
      ) : (
        <Card square className={classes.ticketHeader}>
          {children}
        </Card>
      )}
    </>
  )
}

export default TicketHeader
